import React from "react";
import Entity from "../../components/Entity";
import { MANUFACTURER_STATUS } from "../../Constants";

function Manufacturer() {
  return (
    <Entity
      title={(e) => e.name || "New Manufacturer"}
      formShema={{
        fields: [
          { name: "Name",          propertyName: "name",     type: "input",  col: 8 },
          { name: "Status",        propertyName: "status",   type: "select", options: MANUFACTURER_STATUS, isMulti: false, col: 4 },
          { name: "Civic No",      propertyName: "civicNo",  type: "input",  col: 2 },
          { name: "Street",        propertyName: "street",   type: "input",  col: 5 },
          { name: "City",          propertyName: "city",     type: "input",  col: 5 },
          { name: "Province",      propertyName: "province", type: "input",  col: 4 },
          { name: "Country",       propertyName: "country",  type: "input",  col: 4 },
          { name: "Zip Code",      propertyName: "zipCode",  type: "input",  col: 4 },
          { name: "Tel. No",       propertyName: "telNo",    type: "input",  col: 4 },
          { name: "Fax No",        propertyName: "noFax",    type: "input",  col: 4 },
          { name: "Username",      propertyName: "username", type: "input",  col: 4 },
          { name: "Password",      propertyName: "password", type: "input",  col: 4 },
          { name: "Email Address", propertyName: "email",    type: "input",  col: 4 },
        ],
      }}
    />
  );
}

export default Manufacturer;
